import { Button, Dialog, H2, Text } from '@betterment/samba-react';

interface ReportFieldsDialogProps {
  name: string;
  description?: string | null;
  columns: string[];
}

export const ReportFieldsDialog = ({ reportFields }: { reportFields: ReportFieldsDialogProps }) => {
  return (
    <Dialog>
      <Dialog.Trigger asChild={true}>
        <Button
          aria-label={`See report fields for ${reportFields.name}`}
          variant="textPrimary"
          css={{ color: 'text', textDecoration: 'underline', _hover: { color: 'text' }, _active: { color: 'text' } }}
        >
          See report fields
        </Button>
      </Dialog.Trigger>
      <Dialog.Content
        aria-label={`Fields for ${reportFields.name}`}
        css={{ maxHeight: '85vh', width: 'container.large', p: 'space.400', overflowX: 'scroll' }}
      >
        <Dialog.Title asChild={true}>
          <H2 variant="title300">{reportFields.name}</H2>
        </Dialog.Title>
        <Dialog.Description>{reportFields.description && <Text>{reportFields.description}</Text>}</Dialog.Description>
        <ul>
          {reportFields.columns.map(field => (
            <li key={field}>
              <Text>{field}</Text>
            </li>
          ))}
        </ul>
      </Dialog.Content>
    </Dialog>
  );
};
